import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { MenuController, NavController } from '@ionic/angular';
import { IUser } from 'src/app/models/user.interface';
import { AuthService } from 'src/app/services/guard/auth.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {



  

  /**
   * Sidebar component
   */
  constructor(
    public menuCtrl: MenuController,
  ) {
  }

  ngOnInit() {
    console.log('');
  }


  

  /**
   * Close menu
   */
  close() {
    this.menuCtrl.close();
  }


  /**
   * Logout
   */
  logout() {
    this.menuCtrl.close();
  }
}
